export default __webpack_public_path__ + "67be1e2040e4d0884c099d92b042017f.png";